// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_hlq","cls2":"shared-cls2_I9o shared-cls1_hlq"};